import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ur from './locales/ur.json';

const STORAGE_KEY = 'poultriq_lang';
const PRELOAD_IMAGES = ['about-us.png', 'about-us-urdu.png'];

const savedLanguage = (() => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
})();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ur: { translation: ur },
  },
  lng: savedLanguage || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // ignore
  }
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ur' ? 'rtl' : 'ltr';
});

document.documentElement.lang = i18n.language;
document.documentElement.dir = i18n.language === 'ur' ? 'rtl' : 'ltr';

if (typeof window !== 'undefined') {
  PRELOAD_IMAGES.forEach((imageName) => {
    const image = new window.Image();
    image.src = `${process.env.PUBLIC_URL}/assets/${imageName}`;
  });
}

export default i18n;
